<template>
  <section class="create-model">
    <p-edit-model :is-request-pending="updatePending" @submit="create" />
  </section>
</template>

<script>
import { mapState } from 'vuex';
import EditForm from './_CreateOrEdit';
import organizations from '../../store/organizations';

export default {
  components: {
    'p-edit-model': EditForm
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      models: s => s.administration.modelsConfigurations,
      updatePending: s => s.nlp.updatePending
    })
  },
  methods: {
    async create(model) {
      try {
        const newModel = await this.$store.dispatch('nlp/createModel', model);
        this.$router.push({ path: `/models` });

        this.$toast.success({
          title: 'Created',
          message: `Model '${newModel.name}' succesfully created`
        });
      } catch (error) {
        const { message } = JSON.parse(await error.response.text());
        this.$toast.error({
          title: 'Failed to create model',
          message: message
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.create-model {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-rows: minmax(0, 1fr);
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 1rem;
}
</style>
